<template>
  <div class="bb-h5-shell">
    <div class="bb-h5-fixed">
      <div class="bb-h5-appbar" v-if="showAppBar && !isLogin">
        <div class="bb-h5-appbar-left">
          <div class="bb-h5-app-icon">
            <img src="@/assets/ui/h5/logo-dark.png" alt="logo" />
          </div>
          <div>
            <div class="bb-h5-app-name">{{ $t("home.h5AppName") }}</div>
            <div class="bb-h5-app-desc">{{ $t("home.h5AppDesc") }}</div>
          </div>
        </div>
        <button class="bb-h5-open" type="button" @click="openApp">{{ $t("home.h5Open") }}</button>
        <span class="bb-h5-app-close" @click.stop="closeAppBar">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M9.64746 3.1543L6.75391 6.04785L9.64795 8.94189L8.94092 9.64893L6.04688 6.75488L3.15283 9.64893L2.4458 8.94189L5.33984 6.04785L2.44629 3.1543L3.15332 2.44727L6.04688 5.34082L8.94092 2.44727L9.64746 3.1543Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </div>
      <header class="bb-h5-header">
        <a v-if="!isLogin" class="bb-h5-logo" @click.prevent="$router.push('/')">
          <BrandLogo :mark-only="true" />
        </a>
        <span v-else class="bb-h5-user" @click="$router.push('/profile')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              fill="currentColor"
              d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
            />
          </svg>
        </span>
        <div class="bb-h5-right">
          <button v-if="!isLogin" class="bb-h5-signup" type="button" @click="$router.push(signupPath)">
            {{ $t("navTab.btnSignup") }}
          </button>
          <button v-else class="bb-h5-signup" type="button" @click="$router.push('/profile/deposit')">
            {{ $t("chongZhi") }}
          </button>
          <!-- <span class="bb-h5-icon" @click="openSearch">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                fill="currentColor"
                d="m17.874 16.46 4.283 4.283-1.414 1.414-4.283-4.283a8.96 8.96 0 0 1-5.617 1.97c-4.968 0-9-4.033-9-9 0-4.969 4.032-9 9-9s9 4.031 9 9a8.96 8.96 0 0 1-1.969 5.616m-2.006-.742a6.98 6.98 0 0 0 1.975-4.875c0-3.867-3.132-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975z"
              />
            </svg>
          </span> -->
          <span class="bb-h5-icon" @click="openService">
            <svg width="18" height="18" viewBox="0 0 22 21" fill="currentColor">
              <path
                d="M10.8333 2.16667C6.04686 2.16667 2.16667 6.04686 2.16667 10.8333H5.41667C6.61328 10.8333 7.58333 11.8034 7.58333 13V18.4167C7.58333 19.6133 6.61328 20.5833 5.41667 20.5833H2.16667C0.970049 20.5833 0 19.6133 0 18.4167V10.8333C0 4.85025 4.85025 0 10.8333 0C16.8164 0 21.6667 4.85025 21.6667 10.8333V18.4167C21.6667 19.6133 20.6967 20.5833 19.5 20.5833H16.25C15.0534 20.5833 14.0833 19.6133 14.0833 18.4167V13C14.0833 11.8034 15.0534 10.8333 16.25 10.8333H19.5C19.5 6.04686 15.6198 2.16667 10.8333 2.16667ZM2.16667 13V18.4167H5.41667V13H2.16667ZM16.25 13V18.4167H19.5V13H16.25Z"
              />
            </svg>
          </span>
          <span class="bb-h5-icon menu" @click="drawerOpen = true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path fill="currentColor" d="M3 4h18v2H3zm0 7h18v2H3zm0 7h18v2H3z" />
            </svg>
          </span>
        </div>
      </header>
    </div>
    <div class="bb-h5-spacer" :style="{ height: spacerHeight + 'px' }"></div>

    <div class="bb-h5-search" v-show="searchShow">
      <div class="bb-h5-search-bar">
        <div class="bb-h5-search-input">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              fill="currentColor"
              d="m17.874 16.46 4.283 4.283-1.414 1.414-4.283-4.283a8.96 8.96 0 0 1-5.617 1.97c-4.968 0-9-4.033-9-9 0-4.969 4.032-9 9-9s9 4.031 9 9a8.96 8.96 0 0 1-1.969 5.616m-2.006-.742a6.98 6.98 0 0 0 1.975-4.875c0-3.867-3.132-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975z"
            />
          </svg>
          <input v-model="searchQuery" type="text" :placeholder="$t('souSuo')" />
        </div>
        <button type="button" @click="closeSearch">{{ $t("home.searchCancel") }}</button>
      </div>
      <div class="bb-h5-search-list">
        <div class="bb-h5-search-item" v-for="item in filteredMarketList" :key="item.id" @click="goToMarket(item)">
          <span>{{ item.appName || item.code }}</span>
          <em>{{ item.nowPrice }}</em>
        </div>
        <div class="bb-h5-search-empty" v-if="searchQuery.trim() && !filteredMarketList.length">
          {{ $t("toast.nothingfound") }}
        </div>
      </div>
    </div>

    <div class="bb-h5-drawer" v-show="drawerOpen">
      <div class="bb-h5-drawer-head">
        <span class="bb-h5-drawer-logo" @click="goDrawer('/')">
          <BrandLogo :mark-only="true" />
        </span>
        <span class="bb-h5-drawer-close" @click="drawerOpen = false">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              fill="currentColor"
              d="M10 8.58602L14.9497 3.63627L16.364 5.05048L11.4142 10.0002L16.364 14.95L14.9497 16.3642L10 11.4144L5.05025 16.3642L3.63604 14.95L8.58579 10.0002L3.63604 5.05048L5.05025 3.63627L10 8.58602Z"
            />
          </svg>
        </span>
      </div>
      <div class="bb-h5-drawer-body">
        <div class="bb-h5-auth" v-if="!isLogin">
          <button class="ghost" type="button" @click="goDrawer(authEntryPath)">{{ $t("navTab.btnLogin") }}</button>
          <button class="brand" type="button" @click="goDrawer(signupPath)">{{ $t("navTab.btnSignup") }}</button>
        </div>
        <div class="bb-h5-menu">
          <div v-for="item in drawerList" :key="item.name">
            <div class="bb-h5-menu-row" @click="onMenu(item)">
              <span>{{ item.name }}</span>
              <svg v-if="item.children" :class="{ open: openMenu === item.name }" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="bb-h5-sub" v-if="item.children && openMenu === item.name">
              <div class="bb-h5-menu-row sub" v-for="child in item.children" :key="child.path" @click="goDrawer(child.path)">
                {{ child.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="bb-h5-drawer-foot">
          <div class="bb-h5-lang">
            <button class="bb-h5-lang-row" type="button" @click="isLanguage = !isLanguage">
              <span class="bb-h5-lang-left">
                <span>{{ $t("navTab.language") }}</span>
              </span>
              <span class="bb-h5-lang-now">
                {{ langLabel }}
                <svg :class="{ open: isLanguage }" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </button>
            <div class="bb-h5-langs" v-show="isLanguage">
              <button
                class="bb-lang-item"
                :class="{ active: langIndex == index }"
                type="button"
                v-for="(item, index) in langList"
                :key="item.value || index"
                @click="langChange(index)"
              >
                {{ item.name }}
              </button>
            </div>
          </div>
          <div class="bb-h5-theme-row">
            <span>{{ $t("home.theme") }}</span>
            <ThemeSwitch />
          </div>
        </div>
      </div>
      <div class="bb-h5-download">
        <button type="button" @click="openApp">{{ $t("home.downloadApp") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getAuthEntryPath, getSignupPath } from "@/utils/authRedirect";
import { openCustomerService } from "@/utils/customerService";
import { listMarketByType } from "@/api/market.js";
import BrandLogo from "@/components/BrandLogo.vue";
import ThemeSwitch from "@/components/ThemeSwitch.vue";

export default {
  name: "NavH5",
  components: { BrandLogo, ThemeSwitch },
  data() {
    return {
      showAppBar: true,
      drawerOpen: false,
      openMenu: "",
      isLanguage: false,
      searchShow: false,
      searchQuery: "",
      marketList: [],
      marketListLoading: false
    };
  },
  computed: {
    ...mapGetters(["langList", "langIndex", "getMarkTypeList"]),
    isLogin() {
      return this.$store.state.isLogin;
    },
    authEntryPath() {
      return getAuthEntryPath();
    },
    signupPath() {
      return getSignupPath();
    },
    spacerHeight() {
      return this.showAppBar && !this.isLogin ? 107 : 48;
    },
    langLabel() {
      const item = this.langList && this.langList[this.langIndex];
      return item ? item.name : this.$t("navTab.language");
    },
    drawerList() {
      return [
        // { name: this.$t("navTab.tabMenu8"), path: "/tokenSale" },
        { name: this.$t("navTab.tabMenu2"), path: "/market" },
        { name: this.$t("navTab.smartContract"), path: "/trading" },
        {
          name: this.$t("navTab.trade"),
          children: [
            { name: this.$t("Market.options"), path: "/trade/options" },
            { name: this.$t("Market.contracts"), path: "/trade/futures" }
          ]
        },
        { name: this.$t("tokenSale.title"), path: "/tokenSale" },
        { name: this.$t("account.inviteFriends"), path: "/profile/invite" },
        {
          name: this.$t("navTab.tabMenuMore"),
          children: [
            { name: this.$t("ntfs.NFTs"), path: "/nfts" },
            { name: this.$t("navTab.lending"), path: "/loan" },
            { name: this.$t("navTab.tabMenu7"), path: "/profile" }
          ]
        }
      ];
    },
    filteredMarketList() {
      const query = (this.searchQuery || "").trim().toLowerCase();
      if (!query) return [];
      return this.marketList.filter((item) => {
        return [item.appName, item.name, item.code].some((field) => {
          return field != null && String(field).toLowerCase().includes(query);
        });
      });
    }
  },
  watch: {
    drawerOpen(val) {
      this.lockBody(val || this.searchShow);
      if (!val) {
        this.openMenu = "";
        this.isLanguage = false;
      }
    },
    searchShow(val) {
      this.lockBody(val || this.drawerOpen);
    }
  },
  created() {
    this.showAppBar = localStorage.getItem("bb-h5-appbar-hidden") !== "1";
  },
  beforeDestroy() {
    this.lockBody(false);
  },
  methods: {
    lockBody(lock) {
      document.body.style.overflow = lock ? "hidden" : "";
    },
    closeAppBar() {
      this.showAppBar = false;
      localStorage.setItem("bb-h5-appbar-hidden", "1");
    },
    openApp() {
      this.drawerOpen = false;
      this.$router.push("/profile");
    },
    openService() {
      openCustomerService(this);
    },
    openSearch() {
      this.searchShow = true;
      this.loadAllMarkets();
    },
    closeSearch() {
      this.searchShow = false;
      this.searchQuery = "";
    },
    async loadAllMarkets() {
      if (this.marketListLoading || this.marketList.length > 0) return;
      this.marketListLoading = true;
      try {
        const types = (this.getMarkTypeList || []).map((t) => t.value);
        const responses = await Promise.all(types.map((type) => listMarketByType({ type })));
        const map = new Map();
        responses.forEach((res) => {
          (res.result || []).forEach((item) => {
            if (!map.has(item.id)) {
              map.set(item.id, {
                ...item,
                nowPrice: item.price,
                zdf: item.zdf != null ? (item.zdf * 100).toFixed(2) : "0.00"
              });
            }
          });
        });
        this.marketList = Array.from(map.values());
      } catch (e) {
        this.marketList = [];
      } finally {
        this.marketListLoading = false;
      }
    },
    goToMarket(item) {
      this.closeSearch();
      this.$router.push({
        path: "/trade/futures",
        query: { code: item.code, type: item.type, id: item.id }
      });
    },
    onMenu(item) {
      if (item.children) {
        this.openMenu = this.openMenu === item.name ? "" : item.name;
        return;
      }
      this.goDrawer(item.path);
    },
    goDrawer(path) {
      this.drawerOpen = false;
      if (path) this.$router.push(path);
    },
    langChange(index) {
      const lang = this.langList[index].value;
      this.isLanguage = false;
      this.$store.commit("SET_LANG", lang);
      this.$store.dispatch("listContents", lang == "zh" ? 1 : 2);
    }
  }
};
</script>
<style scoped>
.bb-h5-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: var(--bb-bg);
}
.bb-h5-appbar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--bb-bg);
  color: var(--bb-text);
}
.bb-h5-appbar-left {
  display: flex;
  align-items: center;
  min-width: 0;
}
.bb-h5-app-icon {
  width: 36px;
  height: 36px;
  border-radius: 7.2px;
  border: 1px solid var(--bb-border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}
.bb-h5-app-icon img {
  width: 20px;
  height: 24px;
  object-fit: contain;
  filter: var(--bb-mono-invert);
}
.bb-h5-app-name {
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 5px;
}
.bb-h5-app-desc {
  font-size: 12px;
  line-height: 12px;
  color: var(--bb-text-secondary);
}
.bb-h5-open {
  border: none;
  border-radius: 20px;
  background: var(--bb-bg-input);
  color: var(--bb-text);
  font-size: 12px;
  font-weight: 500;
  padding: 5.5px 16px;
  cursor: pointer;
  margin-right: 8px;
}
.bb-h5-app-close {
  position: absolute;
  top: 6px;
  right: 6px;
  color: var(--bb-text-tertiary);
  width: 12px;
  height: 12px;
  cursor: pointer;
  display: flex;
}
.bb-h5-header {
  height: 48px;
  background: var(--bb-bg);
  color: var(--bb-text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--bb-divider);
  padding-left: 16px;
}
.bb-h5-logo {
  color: var(--bb-text);
  display: inline-flex;
  align-items: center;
  height: 100%;
}
.bb-h5-user {
  display: inline-flex;
  align-items: center;
  height: 100%;
  color: var(--bb-text);
  cursor: pointer;
}
.bb-h5-right {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
}
.bb-h5-signup {
  height: 28px;
  min-width: 56px;
  padding: 0 12px;
  border: none;
  border-radius: 999px;
  background: var(--bb-brand);
  color: var(--bb-always-black);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.bb-h5-signup.ghost {
  background: var(--bb-bg-input);
  color: var(--bb-text);
}
.bb-h5-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--bb-text);
  cursor: pointer;
}
.bb-h5-icon.menu {
  padding-right: 16px;
  box-sizing: content-box;
}
.bb-h5-search,
.bb-h5-drawer {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: var(--bb-bg);
  color: var(--bb-text);
  display: flex;
  flex-direction: column;
}
.bb-h5-search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
}
.bb-h5-search-input {
  flex: 1;
  height: 36px;
  border-radius: 999px;
  background: var(--bb-bg-card);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  color: var(--bb-text-tertiary);
}
.bb-h5-search-input input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--bb-text);
  font-size: 14px;
}
.bb-h5-search-bar button {
  border: 0;
  background: transparent;
  color: var(--bb-text);
  font-size: 14px;
  cursor: pointer;
}
.bb-h5-search-list {
  flex: 1;
  overflow: auto;
  padding: 0 16px 20px;
}
.bb-h5-search-item {
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
  font-size: 14px;
  cursor: pointer;
}
.bb-h5-search-item em {
  font-style: normal;
  color: var(--bb-text-tertiary);
}
.bb-h5-search-empty {
  padding: 24px 0;
  text-align: center;
  color: var(--bb-text-tertiary);
}
.bb-h5-drawer-head {
  position: relative;
  height: 66px;
  flex-shrink: 0;
}
.bb-h5-drawer-logo {
  position: absolute;
  top: 18px;
  left: 12px;
  color: var(--bb-text);
  cursor: pointer;
}
.bb-h5-drawer-close {
  position: absolute;
  top: 22px;
  right: 12px;
  color: var(--bb-text);
  cursor: pointer;
}
.bb-h5-drawer-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.bb-h5-auth {
  display: flex;
  gap: 12px;
  padding: 16px;
}
.bb-h5-auth button {
  flex: 1;
  height: 40px;
  border: 0;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}
.bb-h5-auth .ghost {
  background: var(--bb-bg-input);
  color: var(--bb-text);
}
.bb-h5-auth .brand {
  background: var(--bb-brand);
  color: var(--bb-always-black);
}
.bb-h5-menu-row {
  height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}
.bb-h5-menu-row.sub {
  font-size: 15px;
  font-weight: 400;
  color: var(--bb-text-tertiary);
  height: 48px;
  padding-left: 28px;
}
.bb-h5-menu-row svg {
  color: var(--bb-text-tertiary);
  transition: transform 0.2s;
}
.bb-h5-menu-row svg.open {
  transform: rotate(180deg);
}
.bb-h5-drawer-foot {
  padding: 0 16px 16px;
  border-top: 1px solid var(--bb-divider);
}
.bb-h5-lang-row {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: transparent;
  border: 0;
  color: var(--bb-text);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}
.bb-h5-lang-left,
.bb-h5-lang-now {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.bb-h5-lang-left svg {
  flex-shrink: 0;
  color: var(--bb-text-secondary);
}
.bb-h5-lang-now {
  color: var(--bb-text-secondary);
  font-size: 15px;
  font-weight: 400;
}
.bb-h5-lang-now svg {
  flex-shrink: 0;
  transition: transform 0.2s;
}
.bb-h5-lang-now svg.open {
  transform: rotate(180deg);
}
.bb-h5-langs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 0 0 12px;
}
.bb-h5-langs .bb-lang-item {
  height: 36px;
  padding: 0 10px;
  border: 0;
  border-radius: 8px;
  background: var(--bb-bg-input);
  color: var(--bb-text);
  font-size: 15px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bb-h5-langs .bb-lang-item.active {
  background: var(--bb-brand);
  color: var(--bb-always-black);
  font-weight: 600;
}
.bb-h5-theme-row {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--bb-text);
  font-size: 15px;
  font-weight: 500;
}
.bb-h5-download {
  flex-shrink: 0;
  padding: 12px 16px max(20px, env(safe-area-inset-bottom));
}
.bb-h5-download button {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 999px;
  background: var(--bb-bg-input);
  color: var(--bb-text);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}
</style>
